import { render, staticRenderFns } from "./MobileListAd.vue?vue&type=template&id=4fe2d0f1&"
import script from "./MobileListAd.vue?vue&type=script&lang=js&"
export * from "./MobileListAd.vue?vue&type=script&lang=js&"
import style0 from "./MobileListAd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Link: require('/home/runner/work/myody_front/myody_front/components/link/Link.vue').default})
